export default "__VITE_ASSET__DXyYwitz__"